import React from "react";
import "./scss/pagination.scss";

export default function Pagination({ page, pages, onChange }) {
  if (pages <= 1) return null;

  return (
    <div className="pagination">
      {page > 1 && (
        <button onClick={() => onChange(page - 1)}>‹</button>
      )}

      {Array.from({ length: pages }).map((_, i) => (
        <button
          key={i}
          className={page === i + 1 ? "active" : ""}
          onClick={() => onChange(i + 1)}
        >
          {i + 1}
        </button>
      ))}

      {page < pages && (
        <button onClick={() => onChange(page + 1)}>›</button>
      )}
    </div>
  );
}
